import styled from 'styled-components'

export const TagDropdownWrapper = styled('div')<{minHeight?: string;}>`
  min-height: ${props => props.minHeight || '86px'};
`
